import "./Users.scss";

import React, {useEffect, useState} from "react";
import {StackPanel} from "../panels/StackPanel";
import {QuickSearchText} from "../common/QuickFilterOption";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";
import {UserDto} from "../../domain/UserDto";
import {UsersLocation} from "../../locations/UsersLocation";
import {UserControlsView} from "./UserControlsView";
import {UserManagementService} from "../../services/UserManagementService";
import {AgGridReact} from "ag-grid-react";
import {DefaultGridOptions, DefaultSingleRowSelection, gridTheme, gridThemeDark} from "../../util/AgGridUtil";
import {ColDef, GridOptions, SelectionChangedEvent} from "ag-grid-community";

// interface UserGridRowProps {
//     user: UserDto;
// }
//
// export const UserGridRow: FC<UserGridRowProps> = ({user}) => {
//     return (<>
//
//         <div className="grid-web-id">{user.WebId}</div>
//
//         <div className="grid-mail-id">{user.MailId}</div>
//
//         <div className="grid-web-un">{user.WebUsername}</div>
//
//         <div className="grid-mail-un">{user.MailUsername}</div>
//
//         <div className="grid-dn">{user.DisplayName}</div>
//     </>);
// };

const columnDefs: ColDef<UserDto>[] = [
    {
        field: "WebId",
    },
    {
        field: "MailId",
    },
    {
        field: "WebUsername",
        flex: 1,
    },
    {
        field: "MailUsername",
        flex: 1,
    },
    {
        field: "DisplayName",
        flex: 3,
    },
];

const mobileColumnDefs: ColDef<UserDto>[] = [
    {
        field: "WebUsername",
        width: 110,
    },
    {
        field: "MailUsername",
        width: 110,
    },
    {
        field: "DisplayName",
        flex: 1,
    },
];

const gridOptions: GridOptions<UserDto> = {
    ...DefaultGridOptions,
    defaultColDef: {
        resizable: false,
        sortable: true,
    },
    rowClassRules: {
        "mail-user-row": params => !!params.data?.MailId
    },
};

export const UserListView = () => {

    const dispatch = useAppDispatch();

    const isDarkTheme = useAppSelector(({system}) => system.theme === "dark");

    const [filterText, setFilterText] = useState<string>("");

    const allUsers = useAppSelector(({usersState}) => usersState.users);

    const isMobile = useAppSelector(s => s.system.isMobile);

    const filteredUsers = (filterText.length === 0
        ? [...allUsers]
        : allUsers.filter(k => k.MailUsername?.toLowerCase().includes(filterText) || k.WebUsername?.toLowerCase().includes(filterText)))
        .sort((a, b) => a.WebUsername.localeCompare(b.WebUsername));

    // const selectedUserSelector = ({usersState}: AppState) => usersState.selectedUser ? [usersState.selectedUser] : [];

    useEffect(() => {
        if (allUsers.length === 0) {
            UserManagementService.updateUserList(dispatch);
        }
    }, [allUsers, dispatch]);

    function handleSelectionChanged(params: SelectionChangedEvent<UserDto>) {
        const newSelection = params.api.getSelectedRows();
        UsersLocation.selectUser(newSelection[newSelection.length - 1]?.WebId);
    }

    return (
        <StackPanel orientation="vertical" className="users-list-panel content-item-list">
            <StackPanel orientation="horizontal" className="panel top-panel" align="middle" fill={true}>
                <QuickSearchText onQuickSearchTextChange={text => setFilterText(text.toLowerCase())}
                                 searchPrompt={"Filter Users"}/>
                <UserControlsView/>
            </StackPanel>

            <div className="user-grid">
                <AgGridReact<UserDto> theme={isDarkTheme ? gridThemeDark : gridTheme}
                                      gridOptions={gridOptions}
                                      columnDefs={isMobile ? mobileColumnDefs : columnDefs}
                                      rowSelection={DefaultSingleRowSelection}
                                      rowData={filteredUsers}
                                      getRowId={r => "" + r.data?.WebId}
                                      onSelectionChanged={handleSelectionChanged}
                />
                {/*<SimpleGrid items={filteredUsers}*/}
                {/*            onUpdateSelection={updateGridSelection}*/}
                {/*            rowIdExtractor={u => u.WebId}*/}
                {/*            selectedItemSelector={selectedUserSelector}*/}
                {/*            rowRenderer={user => <UserGridRow user={user}/>}*/}
                {/*            rowClassRules={user => ({"mail-user-row": !!user.MailId})}*/}
                {/*>*/}
                {/*    <div className="grid-web-id">Web Id</div>*/}
                {/*    <div className="grid-mail-id">Mail Id</div>*/}
                {/*    <div className="grid-web-un">Web Username</div>*/}
                {/*    <div className="grid-mail-un">Mail Username</div>*/}
                {/*    <div className="grid-dn">Display Name</div>*/}
                {/*</SimpleGrid>*/}
            </div>
        </StackPanel>
    );
};